import React, { useEffect  } from 'react';
import { useNavigate } from 'react-router-dom';
import AppLogo from '../components/AppLogo';
import AppTitle from '../components/AppTitle';
import Loader from '../assets/images/loader.gif';
import '../App.css';


function SplashScreen() {
    // navigate to Login
    const navigate = useNavigate();
    
    // use effect
    useEffect(() => {
        setTimeout(()=> {
            navigate('/login')
        }, 1800)
    })
    return (
      <div className="App">
        
        <section className=''>
          <div className="flex flex-col items-center justify-center px-6 py-8  mx-auto h-[75vh] md:h-[75vh] lg:py-0">
            <AppLogo />
            <AppTitle title={'WheresPoppin'} description={'Discover places & events'} />
          </div>
          <div className='flex items-center justify-center'>
            <img className="align-bottom" style={{width:'150px'}} src={Loader} alt="logo"/>
          </div>
        </section>
      </div>
    )

}

export default SplashScreen
